import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { ChevronLeft } from 'lucide-react'
import useNavigateBack from 'hooks/useNavigateBack'

type TBackButton = {
  title?: string
  isText?: boolean
  className?: string
  iconClassName?: string
  onClick?: () => void
}

const BackButton: FC<TBackButton> = ({
  title = 'Back',
  isText = true,
  className,
  iconClassName,
  onClick,
}) => {
  const navigateBack = useNavigateBack()

  return (
    <button
      data-testid="back-button"
      className={cn(
        'gap-xxxs flex cursor-pointer items-center text-sm font-semibold text-gray-900 md:px-0',
        className,
      )}
      onClick={onClick || navigateBack}
    >
      <ChevronLeft size={24} className={cn('text-gray-400', iconClassName)} />
      {isText && <span>{title}</span>}
    </button>
  )
}

export default BackButton
